import React, { useEffect, useState } from 'react';
import { get, post } from '../services/apiController';
import { Button, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { roles } from '../util/helper';

function UserProfile() {
  const formFields = { password: '', confirmPassword: '' };
  const [userForm, setUserForm] = useState(formFields);
  const [userData, setUserData] = useState({});

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setUserForm({ ...userForm, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    post(userForm, '/users/current')
      .then((response) => {
        toast.success(response?.data?.message);
        setUserForm(formFields);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 }));
  };

  const fetchUserData = () => {
    try {
      get('/users/current').then((res) => setUserData(res?.data));
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Profile Details
          </h4>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-12 col-lg-12">
              <Row className="top-row">
                <div className="col-md-3">
                  <dd className="display-title mb-1">Id</dd>
                  <dt className="display-value">{userData?.id}</dt>
                </div>
                <div className="col-md-3">
                  <dd className="display-title mb-1">Name</dd>
                  <dt className="display-value">{userData?.name}</dt>
                </div>
                <div className="col-md-3">
                  <dd className="display-title mb-1">Email</dd>
                  <dt className="display-value">{userData?.email}</dt>
                </div>
                <div className="col-md-3">
                  <dd className="display-title mb-1">Mobile No.</dd>
                  <dt className="display-value">{userData?.phone}</dt>
                </div>
                <div className="col-md-3">
                  <dd className="display-title mb-1">Company</dd>
                  <dt className="display-value">{userData?.Company?.name}</dt>
                </div>
                <div className="col-md-3">
                  <dd className="display-title mb-1">Role</dd>
                  <dt className="display-value">
                    {Object.keys(userData?.role || [])
                      .map((role) => roles[role])
                      .join(', ')}
                  </dt>
                </div>
              </Row>
            </div>
          </Row>
          <Row className="justify-content-center">
            <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Update Your Password
              </h4>
            </div>
            <Col xs={4}>
              <form>
                <div className="form-group">
                  <label style={{ fontWeight: 'bold' }} htmlFor="password">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="New Password"
                    value={userForm.password}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label style={{ fontWeight: 'bold' }} htmlFor="confirmPassword">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={userForm.confirmPassword}
                    onChange={handleChange}
                  />
                </div>
                <div className="text-center">
                  <Button type="submit" className="btn app-btn-success" onClick={handleSubmit}>
                    Submit
                  </Button>
                </div>
              </form>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserProfile;
